import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./components/Routes/AppRoutes";
import AppLayout from "./components/Layout/Applayout";
import AuthPage from "./components/Auth/Authpage";
import Dashboard from "./components/Dashboard/Dashboard";
import { Routes, Route, Navigate } from "react-router-dom"; 
import AddRequirement from "./components/Requirement/Requirement";
import ProjectMapping from "./components/projects/ProjectMapping";
// import AddRequirement from "./components/Requirement/Requirement";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<AuthPage />}
        />

        <Route
          path="/dashboard"
          element={
            <AppLayout>
              <Dashboard />
            </AppLayout>
          }
        />
        <Route
          path="/add-requirement"
          element={
            <AppLayout>
              <AddRequirement />
            </AppLayout>
          }
        />
                <Route
          path="/project-mapping"
          element={
            <AppLayout>
              <ProjectMapping />
            </AppLayout>
          }
        />
        <Route
          path="*"
          element={
            <Navigate to="/" />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;